
<div class="div-container">
  <h4>{{heading}}</h4>
  <div class="row">
    <div class="box-container col-xs-12 col-sm-6 col-md-4" *ngFor="let screens of documentScreensList">
      <a [routerLink]="['/literature/details-screen',screens.docGroupingID,screens.docGroupingAlias]">
        <!--skipLocationChange-->
        <div class="boxTitle">
          <h4>
            {{screens.docGroupingAlias}}
          </h4>
        </div>
        <div class="boxBody">
          <img src="../../../../../assets/images/PlaceHolderImg.jpg" class="img-size" alt="">
        </div>
      </a>
    </div>
  </div>
</div>
